import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const ORG_CODE_KEY = 'orgCode';

const loginSearchSchema = z.object({
  orgCode: z.optional(z.string()),
  redirect: z.optional(z.string()),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context: { auth }, location }) => {
    const searchParams = new URLSearchParams(location.search);
    const redirectHint = searchParams.get('redirect');

    if (!auth.isAuthenticated) {
      if (redirectHint === 'signup') {
        await auth.register();
      } else {
        const orgCode = searchParams.get(ORG_CODE_KEY);
        console.log('User is not authenticated, kinde login with orgCode', orgCode);
        await auth.login(orgCode ? { orgCode } : undefined);
      }
    } else {
      const orgCode = searchParams.get(ORG_CODE_KEY);
      const currentOrgCode = await auth.getCurrentOrganization();

      if (orgCode && currentOrgCode !== orgCode) {
        console.log('User is authenticated but with a different org, logging in with orgCode', orgCode);
        await auth.login({ orgCode });
      } else {
        throw redirect({ to: '/' });
      }
    }
  },
});
